export const extractFilename = (caminho: string | null | undefined): string => {
    if (!caminho) return '—';
    const parts = caminho.split('/');
    return parts[parts.length - 1] || '—';
};
